export enum InternalEventType {
	YOLO_PROMPT_REQUESTED = 'yoloPromptRequested',
	YOLO_CREDENTIAL_RETURNED = 'yoloCredentialReturned',
	YOLO_SKIPPED = 'yoloSkipped',
	YOLO_DISMISSED = 'yoloDismissed',
	YOLO_ERROR = 'yoloError',
	/** @deprecated Unreliable under FedCM — use YOLO_PROMPT_REQUESTED instead */
	YOLO_DISPLAYED = 'yoloDisplayed',
	YOLO_INITIALIZED = 'yoloInitialized',
	FACEBOOK_INITIALIZED = 'facebookInitialized',
	OPEN_ID_PERMISSIONS_DISMISSED = 'openIdPermissionsDismissed',
	OPEN_ID_PERMISSIONS_ACCEPTED = 'openIdPermissionsAccepted',
	/** @deprecated Unreliable under FedCM — use YOLO_SKIPPED instead */
	YOLO_NOT_DISPLAYED = 'yoloNotDisplayed',
}
